import studies from '../../api/studies'
import scores from "../../api/scores";

const errors = {
    GET_ALL_STUDIES_LOADING_ERROR: 'Erreur lors du chargement des études, merci de réessayer',
    GET_ACTIVE_STUDIES_LOADING_ERROR: 'Erreur lors du chargement des études, merci de réessayer',
    GET_ALL_SCORES_LOADING_ERROR: 'Erreur lors du chargement des scores, merci de réessayer',
    GET_STUDY_LOADING_ERROR: 'Erreur lors du chargement de l\'étude, merci de réessayer',
    CREATE_STUDY_ERROR: 'Erreur lors de la création de l\'étude, merci de réessayer',
    UPDATE_STUDY_ERROR: 'Erreur lors de la mise à jour de l\'étude, merci de réessayer',
    STUDY_EXPORT_LOADING_ERROR: 'Erreur lors de l\'export de l\'étude, merci de réessayer',
}

const success = {
    CREATE_STUDY_SUCCESS: {
        title: "Succès",
        content: "Etude créée avec succès"
    },
    UPDATE_STUDY_SUCCESS: {
        title: "Succès",
        content: "Etude mise à jour"
    }
}


// initial state
const state = {
    all: [],
    active: [],
    selectedStudy: {
        id: null,
        name: '',
        start_at: null,
        end_at: null,
        status: 'draft',
        treatments: [],
        archived: false,
        block_new_patient: false,
        follow_up_definitions: [
            {
                id: null,
                name: '',
                position: null,
                follow_up_score_definitions: [
                    {
                        score: {
                            name: ''
                        }
                    }
                ]
            }
        ]
    },
    selectedFollowUpDefinition: {
        id: null,
        frequency: 0,
        period: '',
        preop: false,
        scoresForm: [
        ]
    },
    form: {
        name: '',
        start_at: null,
        end_at: null,
        status: 'draft'
    },
    formFollowUp: {
        frequency: 0,
        period: '',
        preop: false,
        scoresForm: [
        ]
    },
    scores: []

}

// getters
const getters = {
    getActiveScores: (state) => {
        return state.scores.filter(score => !score.archived)
    },

    getArchivedScores: (state) => {
        return state.scores.filter(score => score.archived)
    },
}

// actions
const actions = {
    getAllStudies ({ state, commit, rootState }) {
        studies.getStudies(rootState.axios).then(result => {
            commit('setStudies', result.data.studies)
            commit('setScores', result.data.scores)
        }).catch(reason => {
            commit('notifications/showError', {
                title: errors.GET_ALL_STUDIES_LOADING_ERROR, content: reason
            }, { root: true })

        })
    },
    getActiveStudies ({ state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            studies.getActiveStudies(rootState.axios).then(result => {
                commit('setActiveStudies', result.data.studies)
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.GET_ACTIVE_STUDIES_LOADING_ERROR, content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    getAllScores ({ state, commit, rootState }) {
        studies.getScores(rootState.axios).then(result => {
            commit('setScores', result.data.scores)
        }).catch(reason => {
            commit('notifications/showError', {
                title: errors.GET_ALL_SCORES_LOADING_ERROR, content: reason
            }, { root: true })

        })
    },
    getAllScoresByType ({ commit, rootState }, type) {
        scores.getScoresByType(type, rootState.axios).then(result => {
            commit('setScores', result.data.scores)

        }).catch(reason => {
            commit('notifications/showError', {
                title: errors.GET_ALL_SCORES_LOADING_ERROR, content: reason
            }, { root: true })
        })
    },
    getStudyInfo({ state, commit, rootState }) {
        studies.get(state.selectedStudy.id, rootState.axios).then(result => {
            commit('setSelectedStudy', result.data.study)
        }).catch(reason => {
            commit('notifications/showError', {
                title: errors.GET_STUDY_LOADING_ERROR, content: reason
            }, { root: true })

        })
    },
    getStudyExport({ state, commit, rootState }, studyId) {
        return new Promise((resolve, reject) => {
            studies.export(studyId, rootState.axios).then(result => {
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.STUDY_EXPORT_LOADING_ERROR, content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    loadStudyForm({ state, commit, rootState }) {
        studies.get(state.selectedStudy.id, rootState.axios).then(result => {
            commit('initStudyForms', result.data.study)
        }).catch(reason => {
            commit('notifications/showError', {
                title: errors.GET_STUDY_LOADING_ERROR, content: reason
            }, { root: true })

        })
    },

    createStudy({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            studies.add(state.form, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.CREATE_STUDY_SUCCESS.title, content: success.CREATE_STUDY_SUCCESS.content
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.CREATE_STUDY_ERROR, content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },

    updateStudy({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            studies.update(state.selectedStudy.id, state.form, rootState.axios).then(result => {
                commit('setSelectedStudy', result.data.study)
                commit('notifications/showSuccess', {
                    title: success.UPDATE_STUDY_SUCCESS.title, content: success.UPDATE_STUDY_SUCCESS.content
                }, { root: true })

                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_STUDY_ERROR, content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },

    postDeleteStudy({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            studies.delete(state.selectedStudy.id, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.UPDATE_STUDY_SUCCESS.title, content: success.UPDATE_STUDY_SUCCESS.content
                }, { root: true })

                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_STUDY_ERROR, content: reason.response.data.message
                }, { root: true })
                reject(reason)
            })
        });
    },

    loadStudyFollowUp({ state, commit, rootState }) {
        studies.getFollowUp(state.selectedStudy.id, state.selectedFollowUpDefinition.id, rootState.axios).then(result => {
            commit('initFollowUpForms', result.data.followUpDefinition)
        }).catch(reason => {
            commit('notifications/showError', {
                title: errors.GET_STUDY_LOADING_ERROR, content: reason
            }, { root: true })

        })
    },

    createStudyFollowUp({ state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            const formData = state.formFollowUp
            formData.scoresForm.forEach((score, index) => score.position = index)

            studies.addFollowUp(state.selectedStudy.id, formData, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.CREATE_STUDY_SUCCESS.title, content: success.CREATE_STUDY_SUCCESS.content
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.CREATE_STUDY_ERROR, content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },
    updateStudyFollowUp({ state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            const formData = state.formFollowUp
            formData.scoresForm.forEach((score, index) => score.position = index)

            studies.updateFollowUp(state.selectedStudy.id, state.selectedFollowUpDefinition.id, formData, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.UPDATE_STUDY_SUCCESS.title, content: success.CREATE_STUDY_SUCCESS.content
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_STUDY_ERROR, content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },

    deleteStudyFollowUp({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            studies.deleteFollowUp(state.selectedStudy.id, state.selectedFollowUpDefinition.id, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.UPDATE_STUDY_SUCCESS.title, content: success.UPDATE_STUDY_SUCCESS.content
                }, { root: true })

                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_STUDY_ERROR, content: reason.response.data.message
                }, { root: true })
                reject(reason)
            })
        });
    },
    toggleBlockNewPatient({ state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            studies.toggleBlockNewPatient(state.selectedStudy.id, rootState.axios).then(result => {
                commit('setBlockNewPatient', ! state.selectedStudy.block_new_patient)
                commit('notifications/showSuccess', {
                    title: success.UPDATE_STUDY_SUCCESS.title, content: success.UPDATE_STUDY_SUCCESS.content
                }, { root: true })

                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_STUDY_ERROR, content: reason.response.data.message
                }, { root: true })
                reject(reason)
            })
        });
    }
}

// mutations
const mutations = {
    setStudies (state, studies) {
        state.all = studies
    },
    setActiveStudies (state, studies) {
        state.active = studies
    },
    setScores (state, scores) {
        state.scores = scores
    },
    setSelectedStudy(state, value) {
        state.selectedStudy = value
    },
    setSelectedStudyId(state, value) {
        state.selectedStudy.id = value
    },
    setFormName (state, value) {
        state.form.name = value
    },
    setFormStatus (state, value) {
        state.form.status = value
    },
    setFormStartAt (state, value) {
        state.form.start_at = value
    },
    setFormEndAt (state, value) {
        state.form.end_at = value
    },
    initStudyForms(state, data) {
        state.form.name = data.name
        state.form.status = data.status
        state.form.start_at = data.start_at
        state.form.end_at = data.end_at
    },
    setFollowUpPeriod(state, value) {
        state.formFollowUp.period = value
    },
    setFollowUpFrequency(state, value) {
        state.formFollowUp.frequency = value
    },
    setFollowUpPreop(state, value) {
        state.formFollowUp.preop = value
    },
    initFollowUpForms(state, data) {
        if (data.name === 'preop') {
            state.formFollowUp.preop = true
        } else {
            const nameSplit = data.name.split(" ")
            state.formFollowUp.frequency = nameSplit[0]
            state.formFollowUp.period = nameSplit[1]
        }

        state.formFollowUp.scoresForm = data.follow_up_score_definitions.map(definition => definition.score)
    },
    setFollowUpScores(state, data) {
        state.formFollowUp.scoresForm = data
    },
    moveUpFollowUpScore(state, score) {
        const scoreIndex = state.formFollowUp.scoresForm.findIndex(item => item.id === score.id)
        state.formFollowUp.scoresForm.splice(scoreIndex, 1);
        state.formFollowUp.scoresForm.splice(scoreIndex -1, 0, score);
    },
    moveDownFollowUpScore(state, score) {
        const scoreIndex = state.formFollowUp.scoresForm.findIndex(item => item.id === score.id)
        state.formFollowUp.scoresForm.splice(scoreIndex, 1);
        state.formFollowUp.scoresForm.splice(scoreIndex +1, 0, score);
    },
    setSelectedFollowUpDefinition(state, value) {
        state.selectedFollowUpDefinition = value
    },
    setSelectedFollowUpDefinitionId(state, value) {
        state.selectedFollowUpDefinition.id = value
    },
    setBlockNewPatient(state, value) {
        state.selectedStudy.block_new_patient = value
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
